/**
 * Very naive word, or phrase, capitalization.
 *
 * @param {String} phrase A string with words you want to capitalize
 * @returns Capitalized phrase
 *
 * @example
 *   // returns "James"
 *   capitalize('james')
 *
 * @example
 *   // returns "James Herdman"
 *   capitalize('james herdman')
 */
export default function capitalize(phrase) {
  return phrase
    .split(/\s+/)
    .map((word) => {
      const [first, ...rest] = word;
      return [first.toUpperCase(), ...rest].join('');
    })
    .join(' ');
}
